import React, { useState } from 'react';
import { Button } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";

const CustomerFssaiReport = ({ resPacket }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);

  const handleViewItems = (items) => {
    setSelectedItems(items ? items.split(',') : []);
    setIsModalOpen(true);
  };

  return (
    <div>
      {resPacket?.length > 0 ? (
        <div className="customTable" id="scroll">
          <table className="customTable w-100">
            <thead className="fixed-thead">
              <tr>
                <td>SNO.</td>
                <td>Title</td>
                <td>Customer Category</td>
                <td>License NO.</td>
                <td>Expiry Date</td>
              </tr>
            </thead>
            <tbody className="body-scroll-custom">
              {resPacket.map((row, i) => (
                <tr key={i}>
                  <td>{i + 1}</td>
                  <td>{row.title}</td>
                  <td>{row.customerCategory}</td>
                  <td>{row.fssaiLicenseNumber}</td>
                  <td>{row.fssaiValidateDate}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="customTable" id="scroll">No Data Found.</div>
      )}

      <Modal
        show={isModalOpen}
        onHide={() => setIsModalOpen(false)}
        aria-labelledby="contained-modal-title-vcenter"
        runTransition={true}
        centered
      >
        <Modal.Header>
          <Modal.Title>Pallet Items</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ul>
            {selectedItems.length > 0 ? (
              selectedItems.map((item, index) => <li key={index}>{item.trim()}</li>)
            ) : (
              <p>No items available</p>
            )}
          </ul>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={() => setIsModalOpen(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CustomerFssaiReport;
